<template>
    <div class="articleList" :class="{ noPadding: noIndex }">
        <div v-if="!onlyList" class="homeComTitle" :class="[ imgClass ]">
            <span class="flex_1">{{ title }}</span>
            <p class="activeImg flex_box" :style="{backgroundImage: `url(${ isPositive ? positiveActive : negativeActive })`}">
                <span @click="isPositive = false"></span><span @click="isPositive = true"></span>
            </p>
        </div>
        <section v-if="(renderData && renderData[isPositive ? 'positive' : 'negative'].length > 0) || (assignData && assignData.length > 0)">
            <section class="listBox hideLastBorder" :class="addClass">
                <div v-for="(item, index) in (renderData ? renderData[isPositive ? 'positive' : 'negative'] : assignData)"
                     @click.stop="jumpTo(item)" :key="item._id" class="flex_box listItem">
                    <span v-if="!noIndex" class="fs20" :class="[ index === 0 ? 'co_red' : index === 1 ? 'co_orange' : index === 2 ? 'co_green' : 'co_666' ]">{{ index + 1 }}</span>
                    <div class="flex_1">
                        <p class="elli2 fs16">{{ item.title }}</p>
                        <div class="iconBox flex_box mt6">
                            <p class="flex_1 flex_box flex_wrap" v-if="item.tags_v2 && item.tags_v2.length ">
                                <span class="commonTag fs10" v-for="(itemTag, tagIndex) in item.tags_v2" :key="itemTag.key + tagIndex"
                                :class="{ yellowTag: item.tendency === '负面' && itemTag && itemTag.key === 'yinbao', greenTag: item.tendency === '正面', redTag: item.tendency === '负面' }">{{ itemTag.value }}</span>
                            </p>
                            <p class="flex_1 flex_box flex_wrap" v-else>
                                <span class="commonTag fs10" v-for="(itemTag, tagIndex) in item.tags" :key="itemTag + tagIndex"
                                      :class="{ yellowTag: item.tendency === '负面' && itemTag && tagIndex === yibaoTagIndex, greenTag: item.tendency === '正面', redTag: item.tendency === '负面' }">{{ itemTag }}</span>
                            </p>
                        </div>
                        <div class="textBox flex_box mt6">
<!--                            <p class="flex_1 fs10 co_B0">{{ item.media }} {{entity === "article" ? "| 转载量" + item.forwardCount : ""}}</p>-->
                            <p class="flex_1 fs10 co_B0">{{ item.media }} {{item.forwardCount ? "| 转载量" + item.forwardCount : ""}}</p>
                            <span class="text_r timeBox fs10 co_B0">{{ item[timeKey] }}</span>
                        </div>
                    </div>
                </div>
            </section>
<!--            <div v-if="!noIndex" class="text_c co_666 mt12" @click="$emit('checkMore', { isPositive: isPositive })">查看更多</div>-->
        </section>
        <img v-else class="noDataImg mt28" src="../../assets/img/company/noData.svg" alt="">
    </div>
</template>

<script>
const negativeActive = require('../../assets/img/icon/negativeActive.png')
const positiveActive = require('../../assets/img/icon/positiveActive.png')

export default {
    name: "ArticleList",
    props: {
        title: {
            type: String,
            default: '近期报道'
        },
        imgClass: {
            type: String,
            default: 'chartText'
        },
        timeKey: {
            type: String,
            default: 'createdStr'
        },
        entity:{
            type: String,
            default: 'chief'
        },
        renderData: Object,
        assignData: Array,
        assignPositive: Boolean,
        onlyList: Boolean, // 只显示文章列表
        addClass: String,
        noIndex: Boolean,
    },
    data() {
        return {
            negativeActive: negativeActive,
            positiveActive: positiveActive,
            isPositive: false,
            yibaoTagIndex:0
        }
    },
    mounted() {
        this.isPositive = this.assignPositive || false;
        this.yibaoTagIndex = this.entity == "chief"  ? 3: 0;
    },
    methods: {
        jumpTo(item) {
            if(this.entity === "chief")
                return ;

            if(!item.uri)
                return ;
            window.open(item.uri, '_blank');
        }
    }
}
</script>

<style lang="scss" scoped>
.articleList {
    padding: 16px ;
    background-color: #FFFFFF;
    &.noPadding {
        padding: 0 10px 10px;
    }
    .homeComTitle {
        .activeImg {
            width: 80px;
            height: 24px;
            float: right;
            background-size: 100% 100%;
            span {
                width: 50%;
                height: 24px;
            }
        }
    }
    .listBox {
        padding: 0 10px;
        .listItem {
            padding: 15px 0;
            border-bottom: 1px dashed rgba(237,237,237,1);
            > span { line-height: 40px; }
            .fs20 { margin-right: 8px; }
            //.timeBox { width: 80px; }
        }
    }
    .hideLastBorder {
        .listItem:last-child {
            padding: 15px 0px 0px 0px;
            border: none;
        }
    }
}
</style>